import { useSelector } from 'react-redux';
import Button, { Size } from 'lib/Button';
import { getProgrammaticSalesSaveDisabled } from 'store/dealManagement/selectors';
import { getIsDirectSalesCampaignType } from 'store/dealManagement/selectors/getCampaignType';
import usePendoTracking from 'customHooks/usePendoTracking';
import { useProgrammaticShowSaveButton } from 'components/pages/Planner/hooks/useProgrammaticShowSaveButton';
import useIsReadOnly from 'components/pages/Planner/useIsReadOnly';
import { SaveCampaign } from 'components/common/Deal/SaveCampaign';
import { getIsDirectSalesCampaignInfoSaveDisabled } from 'store/dealManagement/selectors/getIsDirectSalesCampaignInfoSaveDisabled';
import { SaveCampaignButtonProps } from './SaveCampaignButton.types';

const SaveCampaignButton: React.FC<SaveCampaignButtonProps> = ({ color }) => {
  const isDirectSalesCampaignType = useSelector(getIsDirectSalesCampaignType);
  const showSaveButton = useProgrammaticShowSaveButton();
  const isDirectSalesSaveDisabled = useSelector(getIsDirectSalesCampaignInfoSaveDisabled);
  const isProgrammaticSaveDisabled = useSelector(getProgrammaticSalesSaveDisabled);
  const isSaveDisabled = isDirectSalesCampaignType ? isDirectSalesSaveDisabled : isProgrammaticSaveDisabled;
  const { isCampaignReadOnly } = useIsReadOnly();

  const { getPendoDataId } = usePendoTracking();

  if (!isDirectSalesCampaignType && !showSaveButton) return null;

  return (
    <SaveCampaign>
      {({ handleSave }) => (
        <Button
          size={Size.FIT_CONTAINER}
          color={color}
          label="Save"
          onClick={handleSave}
          isDisabled={isSaveDisabled || isCampaignReadOnly}
          dataPendoId={getPendoDataId('Bottom Save Campaign')}
        />
      )}
    </SaveCampaign>
  );
};

export default SaveCampaignButton;
